import { AnyAction, Dispatch } from '@reduxjs/toolkit'
import { VisibleAssets } from '../../../../app/components/Molecules/MapView/RiskMapView/RiskMapView.utilities'
import { updateMapStateProperty } from '../../../../app/redux/riskMap/riskMapSlice'

export function handleUpdateVisibleAssets({
  visibleAssets,
  dispatch,
}: {
  visibleAssets: VisibleAssets
  dispatch: Dispatch<AnyAction>
}) {
  dispatch(updateMapStateProperty({ visibleAssets }))
}
